import React from "react";
import { Spin } from "antd";
import { useThemeMode } from "../theme/ThemeProvider";
import { getAirsmartLogo } from "../theme/brandingConfig";

const AppLoadingScreen = () => {
  const { mode } = useThemeMode();
  const isDark = mode === "dark";
  const loadingLogo = getAirsmartLogo(mode);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: isDark
          ? "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))"
          : "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
        backgroundRepeat: "no-repeat",
        zIndex: 99999,
      }}
    >
      <style>{`
        @keyframes app-loading-pulse {
          0% { transform: scale(0.95); opacity: 0.8; }
          50% { transform: scale(1.05); opacity: 1; }
          100% { transform: scale(0.95); opacity: 0.8; }
        }
      `}</style>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          animation: "fadeIn 1s ease-in-out",
        }}
      >
        <img
          src={loadingLogo}
          alt="AirSmart Logo"
          style={{
            width: 220,
            height: "auto",
            marginBottom: 24,
            animation: "app-loading-pulse 1.5s infinite ease-in-out",
          }}
        />
        <Spin size="large" />
      </div>
    </div>
  );
};

export default AppLoadingScreen;
